import React from "react";
import SharedHeader from "../../../components/Shared/Header";

const Header = () => <SharedHeader title="Kunde 1" />;

export default Header;
